<template>
  <v-container id="sms" class="fill-height">
    <div v-if="isLoading" justify="center" align="center">
      <v-col class="12">
        <v-progress-circular indeterminate color="purple"></v-progress-circular>
      </v-col>
      <v-col class="12">
        <p>Validando...</p>
      </v-col>
    </div>

    <v-row v-else justify="center" align="center">
      <v-col v-if="success" cols="10">
        <v-card flat :loading="isLoading" class="mx-auto my-12" max-width="500">
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <v-img
            class="white--text align-end"
            height="400px"
            gradient="to bottom, rgba(0,0,0,.1) 70%, rgba(0,0,0,.5) 100%"
            :src="require('@/assets/images/sms.jpg')"
          >
            <v-card-title>Suscripción hecha. Te contactaremos </v-card-title>
          </v-img>

          <!-- <v-card-actions>
            <v-btn color="deep-purple lighten-2" text @click="reserve">
              Reserve
            </v-btn>
          </v-card-actions> -->
        </v-card>
      </v-col>

      <v-col v-else-if="!success">
        <v-alert outlined type="error" text>
          <!-- <h2 class="text-h5 mb-5 text-center">
            No iniciar sesión
          </h2> -->
          <p class="mt-5 text-paragraph text-center">
            {{ errorMessage }}
          </p>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  data() {
    return {
      isLoading: true,
      token: "",
      errorMessage:
        "El proceso de verificacion ha fallado, por favor intente nuevamente",
      success: false,
    };
  },

  mounted() {
    this.token = this.$route.params.token;
    this.verifyToken();
  },

  methods: {
    async verifyToken() {
      this.isLoading = true;

      try {
        const { data } = await PbxHttpClient.post("/sms/register/accept", {
          token: this.token,
        });
        // console.log("data", res);

        this.success = true;
      } catch (err) {
        this.errorMessage = err.response.data.message;
        // this.$snotify.error(err.response.data.message, "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
